import { FormSectionHandler } from '../entity.handler';
import { VendorResponse, VendorUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField, EntityUtils, ComboField, TagsField } from '../utils';
import { COMPANY_ICONS } from '../icons';
import { nullAccessDenied } from 'app/services';

interface EditorValues {
    name?: string;
    website?: string;
    tags?: string[];
    group?: string;
}

export class VendorDetailsSectionHandler implements FormSectionHandler<VendorResponse, EditorValues> {

    type = 'form';
    icon = COMPANY_ICONS.vendor;
    bulk = true;

    readonly = this.admin.user.owner.type === 'vendor';
    
    title = this.translate('TITLE'); 
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    private properties = ['name', 'website', 'tags', 'group'];

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.VENDOR.DETAILS.${key}`, values);
    }

    applyUpdate(entity: VendorResponse, payload: VendorUpdateRequest): Promise<VendorResponse> {
        return this.admin.applyUpdate(api => api.accounts.updateVendor(entity.id, payload), { _navigation: 'vendor' });
    }

    mapEntityToEditor(entity: VendorResponse): Promise<EditorValues> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, entity, {}));
    }

    mapEditorToEntity(entity: any, values: EditorValues): Promise<any> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, values, entity));
    }

    getFields(entity: VendorResponse): Promise<FormBuilderField[]> {
        return Promise.all([
            this.readonly ? null : this.admin.getCached(`listCompanyGroups/${this.ownerId}`, api => api.accounts.listCompanyGroups(this.ownerId)).catch(nullAccessDenied),
        ]).then(([vendorGroups]) => {
            const groups = vendorGroups && vendorGroups.items.map(x => ({ key: x.id, value: x.name })).sort((a, b) => a.value.localeCompare(b.value));
            return [
                TextField('name', this.translate('FIELDS.NAME'), true, 1, 255),
                TextField('website', this.translate('FIELDS.WEBSITE'), true, 1, 255),
                groups && ComboField('group', this.translate('FIELDS.GROUP'), false, groups),
                TagsField('tags', this.translate('FIELDS.TAGS'), false),
            ].filter(x => x);

        }).then(fields => EntityUtils.prepareBulk(!entity, ['group'], fields));
    }

}
